module.exports = __webpack_public_path__ + "static/media/sfx_animal_zebra.e62ba332.mp3";